// Helpers
import { getStorageItem } from '@nephro/commons/helpers/storage-helper';
import i18n from 'i18next';

export const internalType = 'accessToken';
export const externalType = 'token';

const tokenInterceptor = (config) => {
  const oktaTokenStorage = getStorageItem('okta-token-storage');
  const token = getStorageItem('token');
  const appToken = token || oktaTokenStorage?.accessToken?.accessToken;

  const authToken = `Bearer ${appToken}`;

  const headers = {
    ...config?.headers,
    Language: `${i18n.language}`,
    ...(appToken ? { Authorization: authToken } : {})
  };

  return { ...config, headers };
};

export default tokenInterceptor;
